import React from 'react';

const VIDEO_STEPS = ['準備', '最適化', '生成', '保存'] as const;

const stepIndex = (step?: string | null): number => {
  switch (step) {
    case 'optimizing_prompt':
      return 1;
    case 'generating':
      return 2;
    case 'downloading':
    case 'uploading':
    case 'saving':
      return 3;
    case 'completed':
      return 4;
    default:
      return 0;
  }
};

interface ToolCardProgressProps {
  percent?: number | null;
  /** 動画ジョブの progress_step。指定時は 4 段ステップを出す */
  step?: string | null;
  hint?: string;
}

/**
 * 進捗表示: ％バー＋（動画なら）準備→最適化→生成→保存 の段階。
 */
const ToolCardProgress: React.FC<ToolCardProgressProps> = ({ percent, step, hint }) => {
  const value = Math.max(0, Math.min(100, typeof percent === 'number' ? percent : 0));
  const current = step !== undefined ? stepIndex(step) : null;

  return (
    <div>
      {current !== null && (
        <ol className="mb-1.5 flex items-center gap-1 text-[11px]">
          {VIDEO_STEPS.map((name, i) => {
            const done = i < current;
            const active = i === current;
            return (
              <li key={name} className="flex items-center gap-1">
                <span className={`h-1.5 w-1.5 rounded-full ${done ? 'bg-violet-500' : active ? 'bg-violet-400 animate-pulse' : 'bg-gray-300'}`} aria-hidden="true" />
                <span className={active ? 'font-medium text-violet-700' : done ? 'text-gray-500' : 'text-gray-400'}>{name}</span>
                {i < VIDEO_STEPS.length - 1 && (
                  <span className="mx-0.5 text-gray-300" aria-hidden="true">
                    ›
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      )}
      <div className="flex items-center gap-2">
        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-gray-200">
          <div className="h-full rounded-full bg-violet-500 transition-all" style={{ width: `${value}%` }} />
        </div>
        <span className="w-9 text-right text-xs tabular-nums text-gray-600">{value}%</span>
      </div>
      {hint && <p className="mt-1 text-[11px] text-gray-400">{hint}</p>}
    </div>
  );
};

export default ToolCardProgress;
